module.exports = __webpack_public_path__ + "static/media/conner-theme.a2f70784.wav";